import React from 'react';
import { ChevronDown, ChevronRight, Check, X } from 'lucide-react';
import { STATUS } from './betaAdminApi';

const Tick = ({ on, label, id }) => (
  <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${on ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-500'}`} data-testid={id}>
    {on ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}{label}
  </span>
);

export const BetaTesterRow = ({ t, open, onToggle }) => {
  const [label, tone] = STATUS[t.status] || STATUS.active;
  const bp = t.betaProgram;
  return (
    <button type="button" onClick={onToggle} className="w-full text-left px-4 py-3 flex flex-col lg:flex-row lg:items-center gap-2 lg:gap-4 hover:bg-slate-50"
      data-testid={`beta-tester-row-${t.practiceId}`}>
      <span className="flex items-center gap-2 min-w-0 lg:w-72">
        {open ? <ChevronDown className="w-4 h-4 shrink-0" /> : <ChevronRight className="w-4 h-4 shrink-0" />}
        <span className="min-w-0">
          <span className="block font-semibold text-slate-900 truncate">{t.application?.fullName || t.practiceName}</span>
          <span className="block text-xs text-slate-500 truncate">{t.practiceName} · {bp.cityState}</span>
        </span>
      </span>
      <span className={`text-xs font-semibold px-2 py-1 rounded-full w-fit ${tone}`} data-testid={`beta-tester-status-${t.practiceId}`}>
        {label}{t.daysLeft != null && t.status !== 'ended' ? ` · ${t.daysLeft}d left` : ''}
      </span>
      <span className="flex flex-wrap gap-1.5 lg:ml-auto">
        <Tick on={t.baaSigned} label="HIPAA" id={`beta-tick-baa-${t.practiceId}`} />
        <Tick on={!!bp.testimonialText} label="Testimonial" id={`beta-tick-testimonial-${t.practiceId}`} />
        <Tick on={t.hasPhoto} label="Photo" id={`beta-tick-photo-${t.practiceId}`} />
        <Tick on={!!bp.reviewReceived} label="5★ review" id={`beta-tick-review-${t.practiceId}`} />
        <Tick on={!!bp.publishedTestimonialId} label="Published" id={`beta-tick-published-${t.practiceId}`} />
      </span>
    </button>
  );
};
